import { render, staticRenderFns } from "./YouTubeDrDave.vue?vue&type=template&id=23775e22"
import script from "./YouTubeDrDave.vue?vue&type=script&lang=ts"
export * from "./YouTubeDrDave.vue?vue&type=script&lang=ts"
import style0 from "./YouTubeDrDave.vue?vue&type=style&index=0&id=23775e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports